import RouteComponent from './Components/RouteComponent';
import './App.css';

function App() {
  return (
      <RouteComponent />
  );
}

export default App;
